import { REQUEST_URL } from "../constants";
import { PaginationQueryModel, FaqInputModel } from "../models";
import { RequestUtil } from "../utils";

export const FaqService = {
  filterFaqs,
  createFaq,
  updateFaq,
  deleteFaq,
  getFaqById,
};

function filterFaqs(
  query: PaginationQueryModel & { searchValue?: string } & { status?: string[] } & { languageId?: string } = {},
) {
  const url = REQUEST_URL.FILTER_FAQ;

  return RequestUtil.get({ url, query: query });
}

function createFaq(data: FaqInputModel[]) {
  const url = REQUEST_URL.CREATE_FAQ;

  return RequestUtil.post({ url, data });
}

function updateFaq(faqId: string, data: FaqInputModel[]) {
  const url = REQUEST_URL.UPDATE_FAQ.replace("{FAQ_ID}", faqId);

  return RequestUtil.put({ url, data });
}

function deleteFaq(faqId: string) {
  const url = REQUEST_URL.DELETE_FAQ.replace("{FAQ_ID}", faqId);

  return RequestUtil.delete({ url });
}

function getFaqById(faqId: string) {
  const url = `/qa/${faqId}`;

  return RequestUtil.get({ url });
}
